/**
 * @generated SignedSource<<3423eb0f6463206a6aae2995d841c4bd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentServiceLevelAgreementFragment$data = {
  readonly id: string;
  readonly serviceLevelAgreementThresholds: {
    readonly infoUntil: string;
    readonly warningUntil: string;
  } | null;
  readonly " $fragmentType": "appointmentServiceLevelAgreementFragment";
};
export type appointmentServiceLevelAgreementFragment$key = {
  readonly " $data"?: appointmentServiceLevelAgreementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentServiceLevelAgreementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentServiceLevelAgreementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceLevelAgreementThresholds",
      "kind": "LinkedField",
      "name": "serviceLevelAgreementThresholds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "infoUntil",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "warningUntil",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};

(node as any).hash = "d91ae13582951fc3350c428a56999532";

export default node;
